import { useTranslation } from '@/hooks/use-translation'
import { Main } from '@/components/layout/main'
import { UnifiedHeader } from '@/components/layout/unified-header'
import { OrganizationsTable } from './organizations-table'

export default function AdminOrganizations() {
  const { t } = useTranslation()

  return (
    <>
      <UnifiedHeader />

      <Main>
        <div className='mb-2 flex flex-wrap items-center justify-between space-y-2'>
          <div>
            <h2 className='text-2xl font-bold tracking-tight'>
              {t('organizations.organizationManagement')}
            </h2>
            <p className='text-muted-foreground'>
              {t('organizations.manageOrganizationsHere')}
            </p>
          </div>
        </div>

        <div className='flex-1 overflow-auto'>
          <OrganizationsTable columns={[]} />
        </div>
      </Main>
    </>
  )
}
